module.exports = __webpack_public_path__ + "static/candidate-389464c70d82d2e76fe4a8df99650677.png";